function LandingWaveSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="214px"
      viewBox="0 0 1440 214px"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 81.5993C0 81.5993 203.75 191.021 342.946 182.166C482.143 173.312 565.528 136.814 718.478 155.063C871.428 173.312 1315.06 127.272 1440 0.557617V213.758H0V81.5993Z"
        fill="white"
      />
    </svg>
  );
}

function FacilityLocationSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clip-path="url(#clip0_6255_57378)">
        <path
          d="M21 10.7637C21 17.7637 12 23.7637 12 23.7637C12 23.7637 3 17.7637 3 10.7637C3 8.37672 3.94821 6.08754 5.63604 4.39971C7.32387 2.71188 9.61305 1.76367 12 1.76367C14.3869 1.76367 16.6761 2.71188 18.364 4.39971C20.0518 6.08754 21 8.37672 21 10.7637Z"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 13.7637C13.6569 13.7637 15 12.4205 15 10.7637C15 9.10682 13.6569 7.76367 12 7.76367C10.3431 7.76367 9 9.10682 9 10.7637C9 12.4205 10.3431 13.7637 12 13.7637Z"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6255_57378">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.763672)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function FacilityGridSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M10 3.76367H3V10.7637H10V3.76367Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 3.76367H14V10.7637H21V3.76367Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 14.7637H14V21.7637H21V14.7637Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 14.7637H3V21.7637H10V14.7637Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function FacilityListSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M8 6.76367H21"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 12.7637H21"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 18.7637H21"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 6.76367H3.01"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 12.7637H3.01"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 18.7637H3.01"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function LocationSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
    >
      <path
        d="M6 14.5L2.0225 10.5459C1.23584 9.76388 0.700116 8.7675 0.48308 7.68278C0.266044 6.59806 0.377442 5.47373 0.803187 4.45195C1.22893 3.43017 1.9499 2.55684 2.87493 1.9424C3.79995 1.32796 4.88748 1 6 1C7.11252 1 8.20005 1.32796 9.12507 1.9424C10.0501 2.55684 10.7711 3.43017 11.1968 4.45195C11.6226 5.47373 11.734 6.59806 11.5169 7.68278C11.2999 8.7675 10.7642 9.76388 9.9775 10.5459L6 14.5ZM9.09375 9.66737C9.70556 9.0591 10.1222 8.28414 10.291 7.44048C10.4597 6.59682 10.3731 5.72236 10.0419 4.92766C9.71078 4.13297 9.15003 3.45374 8.43057 2.97585C7.71112 2.49797 6.86527 2.24291 6 2.24291C5.13473 2.24291 4.28888 2.49797 3.56943 2.97585C2.84997 3.45374 2.28922 4.13297 1.95807 4.92766C1.62693 5.72236 1.54026 6.59682 1.70903 7.44048C1.87781 8.28414 2.29444 9.0591 2.90625 9.66737L6 12.7429L9.09375 9.66737ZM6 7.83448C5.66848 7.83448 5.35054 7.70355 5.11612 7.47051C4.8817 7.23747 4.75 6.9214 4.75 6.59183C4.75 6.26227 4.8817 5.9462 5.11612 5.71316C5.35054 5.48011 5.66848 5.34919 6 5.34919C6.33152 5.34919 6.64946 5.48011 6.88388 5.71316C7.1183 5.9462 7.25 6.26227 7.25 6.59183C7.25 6.9214 7.1183 7.23747 6.88388 7.47051C6.64946 7.70355 6.33152 7.83448 6 7.83448Z"
        fill="black"
        stroke="black"
        stroke-width="0.5"
      />
    </svg>
  );
}

function PendingSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_8373_104295)">
        <path
          d="M7.00033 12.8327C10.222 12.8327 12.8337 10.221 12.8337 6.99935C12.8337 3.77769 10.222 1.16602 7.00033 1.16602C3.77866 1.16602 1.16699 3.77769 1.16699 6.99935C1.16699 10.221 3.77866 12.8327 7.00033 12.8327Z"
          stroke="#D1691D"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7 3.5V7L9.33333 8.16667"
          stroke="#D1691D"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8373_104295">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function BackIconSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="15"
      viewBox="0 0 10 15"
      fill="none"
    >
      <path
        d="M9.15781 0.366899C9.06589 0.274743 8.95668 0.201627 8.83646 0.151739C8.71623 0.101851 8.58735 0.0761719 8.45718 0.0761719C8.32702 0.0761719 8.19813 0.101851 8.07791 0.151739C7.95768 0.201627 7.84848 0.274743 7.75656 0.366899L1.17781 6.94565C1.10442 7.01889 1.04619 7.10588 1.00646 7.20165C0.966738 7.29743 0.946289 7.40009 0.946289 7.50377C0.946289 7.60746 0.966738 7.71012 1.00646 7.80589C1.04619 7.90166 1.10442 7.98866 1.17781 8.0619L7.75656 14.6406C8.14447 15.0286 8.76989 15.0286 9.15781 14.6406C9.54573 14.2527 9.54573 13.6273 9.15781 13.2394L3.42614 7.49982L9.16572 1.76023C9.54572 1.38023 9.54573 0.746899 9.15781 0.366899Z"
        fill="#2B3D41"
      />
    </svg>
  );
}

function BreadcrumbDividerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
    >
      <path
        d="M3.38268 9.63051C3.4359 9.68387 3.49912 9.7262 3.56873 9.75508C3.63833 9.78396 3.71295 9.79883 3.78831 9.79883C3.86366 9.79883 3.93828 9.78396 4.00789 9.75508C4.07749 9.7262 4.14071 9.68387 4.19393 9.63051L8.00268 5.82176C8.04517 5.77936 8.07888 5.72899 8.10188 5.67355C8.12488 5.6181 8.13672 5.55866 8.13672 5.49864C8.13672 5.43861 8.12488 5.37917 8.10188 5.32373C8.07888 5.26828 8.04517 5.21792 8.00268 5.17551L4.19393 1.36676C3.96935 1.14218 3.60726 1.14218 3.38268 1.36676C3.1581 1.59135 3.1581 1.95343 3.38268 2.17801L6.70102 5.50093L3.3781 8.82385C3.1581 9.04385 3.1581 9.41051 3.38268 9.63051Z"
        fill="#2B3D41"
      />
    </svg>
  );
}

export {
  LandingWaveSvg,
  FacilityLocationSvg,
  FacilityGridSvg,
  FacilityListSvg,
  LocationSvg,
  PendingSvg,
  BackIconSvg,
  BreadcrumbDividerIcon,
};
